import UdeskLocales from 'UdeskLocales';
import React, { FC } from 'react';
import { Radio, Space, Tooltip } from 'udesk-ui';
import { InformationOutlined } from '@udesk/icons';
import { RadioProps } from 'antd';

export const QA_METHOD = {
    BATCH: 1,
    SINGLE: 0,
};

interface TemplateProps extends Omit<RadioProps, 'value' | 'onChange'> {
    value?: number;
    onChange?: (v?: TemplateProps['value']) => void;
}

const Template: FC<TemplateProps> = (props) => {
    const { value, onChange, disabled } = props;

    return (
        <Space align="baseline">
            <Space>
                <div>
                    <span>
                        {/* 质检方式 */}
                        {
                            UdeskLocales['current'].components.customModelsQaMethod.index
                                .qualityInspectionMethod
                        }
                    </span>
                    <Tooltip
                        title={
                            <div style={{ whiteSpace: 'pre-wrap' }}>
                                <div>
                                    {/* 设置当前质检规则的大模型质检方式； */}
                                    {
                                        UdeskLocales['current'].components.customModelsQaMethod
                                            .index
                                            .setTheLargeModelQualityInspectionMethodOfTheCurrentQualityInspectionRule
                                    }
                                </div>
                                <div>
                                    {/* 批量质检：表示将当前规则与同任务下其他批量质检的规则合并后，调用大模型一次性输出多条规则的质检结果，适用于简单规则。 */}
                                    {
                                        UdeskLocales['current'].components.customModelsQaMethod
                                            .index
                                            .batchQualityInspectionAfterTheCurrentRuleIsMergedWithOtherBatchQualityInspectionRulesUnderTheSameTaskTheLargeModelIsCalledToOutputTheQualityInspectionResultsOfMultipleRulesAtOneTimeThisIsApplicableToSimpleRules
                                    }
                                </div>
                                <div>
                                    {/* 单独质检：表示当前规则不与其他规则合并，单独进行质检，适用于复杂规则。 */}
                                    {
                                        UdeskLocales['current'].components.customModelsQaMethod
                                            .index
                                            .separateQualityInspectionIndicatesThatTheCurrentRuleIsNotMergedWithOtherRulesAndQualityInspectionIsPerformedSeparatelyThisIsApplicableToComplexRules
                                    }
                                </div>
                                <div>
                                    {/* 注意单独质检token消耗量要高于批量质检。 */}
                                    {
                                        UdeskLocales['current'].components.customModelsQaMethod
                                            .index
                                            .noteThatTheConsumptionOfIndividualQualityInspectionTokenIsHigherThanThatOfBatchQualityInspection
                                    }
                                </div>
                            </div>
                        }
                    >
                        <InformationOutlined />
                    </Tooltip>
                    <span>:</span>
                </div>
            </Space>

            <Radio.Group
                value={value}
                onChange={(v) => onChange?.(v.target.value)}
                options={[
                    {
                        label: /* 批量质检 */ UdeskLocales['current'].components
                            .customModelsQaMethod.index.batchQualityInspection,
                        value: QA_METHOD.BATCH,
                    },
                    {
                        label: /* 单独质检 */ UdeskLocales['current'].components
                            .customModelsQaMethod.index.separateQualityInspection,
                        value: QA_METHOD.SINGLE,
                    },
                ]}
                disabled={disabled}
            />
        </Space>
    );
};

export default Template;
